<style lang="less">

</style>

<template>
  <div class="search-wrap">
    <div class="sub-thumb"></div>
    <div class="nav-search">
      <div class="search-field">
        <input type="text" class="search-input" placeholder="全站搜索">
        <button class="search-btn">搜索</button>
      </div>
      <div class="search-hot-word">
        <span>搜索热词</span>
        <ul>
          <li><a href="javascript:void(0)">API调用示例</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "page-search"
  }
</script>
